/**
 * ConnectivityModal.tsx — the Connectivity wizard in a Modal shell.
 *
 * Opened from the top-right Connectivity button (start page + Studio
 * MenuBar). Render it persistently with `isOpen` (the animated mount/unmount
 * contract) so the exit animation plays; each open remounts the wizard fresh,
 * re-deriving its start step from the live probes.
 */
import { Modal } from '../panels/Modal';
import { ConnectivityWizard } from './ConnectivityWizard';

export function ConnectivityModal({
  isOpen,
  onClose,
}: {
  isOpen?: boolean;
  onClose: () => void;
}): JSX.Element {
  return (
    <Modal title="Connectivity" size="wide" isOpen={isOpen} onClose={onClose}>
      <ConnectivityWizard onClose={onClose} />
    </Modal>
  );
}
